import { FunctionComponent, useState } from "react"
import { Button, Table } from "react-bootstrap"
import { Role } from "../data/models.interface"
import { sortArray } from "../utils/ArrayUtils"
import EntityRoleIdModal from "./EntityRoleIdModal"

interface IRoleIdsSubForm {
	roleIds: string[]
	setRoleIds: (value: string[]) => any
	roles: Role[]
}
const RoleIdsSubForm: FunctionComponent<IRoleIdsSubForm> = ({ roleIds, setRoleIds, roles }) => {
	// this is which row is open in the modal; undefined means the modal is closed
	const [modalIndex, setModalIndex] = useState<number | null>(null)
	// sorting will call setValue with the items in a new order
	const sortBy = (sortProperty: string) => setRoleIds(sortArray(roleIds, sortProperty, "AUTO"))
	//
	return (
		<>
			<EntityRoleIdModal
				onHide={() => setModalIndex(null)}
				roleIds={roleIds}
				setRoleIds={setRoleIds}
				index={modalIndex}
				roles={roles}
			/>
			<Table striped bordered hover size="sm">
				<thead>
					<tr>
						<th onClick={() => sortBy("")}>Role</th>
					</tr>
				</thead>
				<tbody>
					{roleIds?.map((roleId, i) => (
						<tr key={roleId} onClick={() => setModalIndex(i)}>
							<td>{roles.find((r) => r.id === roleId)?.name}</td>
						</tr>
					))}
					<tr>
						<td colSpan={10} className="text-center">
							<Button variant="outline-success" size="sm" onClick={() => setModalIndex(roleIds?.length || 0)}>
								Add Role
							</Button>
						</td>
					</tr>
				</tbody>
			</Table>
		</>
	)
}
export default RoleIdsSubForm
